// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MWQd","colMin":"styles_colMin__2rRkn"};